import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { catchError, map, tap } from 'rxjs/operators';
import { Client } from '../models/clients/client';
import { LogService } from './log.service';
import { MessagesService } from './messages.service';
import { CommonService } from './common.service';
import { PageOption } from '../models/common/pageOption';
import { KeyValuePair } from '../models/common/keyValuePair';
import { ClientFilter } from '../models/clients/clientFilter';
import { CACHE_KEYS } from '../contants/CACHE_KEYS';
import { CacheService } from './cache.service';
import { environment } from '../../environments/environment';
import { RequestResult } from '../models/common/requestResult';
import { PageOptionResult } from '../models/common/pageOptionResult';

@Injectable()
export class ClientService {
	private origin: string = environment.API_BASE_URL;

	constructor(
		private _http: HttpClient,
		private _logService: LogService,
		private _messagesService: MessagesService,
		private _common: CommonService,
		private _cacheService: CacheService
	) { }

	getClient(id: number): Observable<Client> {
		return this._http.get<Client>(`${this.origin}/api/clients/${id}`)
			.pipe(
				tap(x => this.log(`getClient: id=${id}`)),
				catchError(this._logService.handleError<Client>('getClient'))
			);
	}

	getClientsList(filter: PageOption<ClientFilter>): Observable<PageOptionResult<Client>> {
		let param = this._common.objectToQueryParam(filter);
		return this._http.get<PageOptionResult<Client>>(`${this.origin}/api/clients/${param}`)
			.pipe(
				tap(x => this.log(`getClientsList param = ${param}`)),
				catchError(this._logService.handleError<PageOptionResult<Client>>('getClientsList'))
			);
	}

	getClientsDropdownList(): Observable<KeyValuePair[]> {
		let value = this._cacheService.get(CACHE_KEYS.clientSelection)
		if (value != null) {
			return of(value);
		}

		return this._http.get<KeyValuePair[]>(`${this.origin}/api/menus/clients`)
			.pipe(
				tap(x => {
					this.log(`getClientsDropdownList`);
					if(x != undefined){
						this._cacheService.add(CACHE_KEYS.clientSelection, x, 120)
					}
				}),
				catchError(this._logService.handleError<KeyValuePair[]>('getClientsDropdownList'))
			);
	}

	addClient(client: Client): Observable<RequestResult<Client>> {
		this._cacheService.remove(CACHE_KEYS.clientSelection); //remove custom cache
		return this._http.post<RequestResult<Client>>(`${this.origin}/api/clients`, JSON.stringify(client))
			.pipe(
				tap(x => this.log(`addClient: id=${client.name}`)),
				catchError(this._logService.handleError<RequestResult<Client>>('addClient'))
			);
	}

	updateClient(client: Client): Observable<RequestResult<Client>> {
		this._cacheService.remove(CACHE_KEYS.clientSelection); //remove custom cache
		return this._http.put<RequestResult<Client>>(`${this.origin}/api/clients/${client.id}`, JSON.stringify(client))
			.pipe(
				tap(x => this.log(`updateClient: id=${client.id}`)),
				catchError(this._logService.handleError<RequestResult<Client>>('updateClient'))
			);
	}

	copy(source: Client): Client {
		if(source === undefined || source === null){
			return null;
		}
		let copy = new Client();
		copy.id = source.id;
		copy.name = source.name;
		copy.dateAccredited = source.dateAccredited;
		copy.createdBy = source.createdBy;
		copy.createdDate = source.createdDate;
		copy.updatedBy = source.updatedBy;
		copy.updatedDate = source.updatedDate;
		return copy;
	}

	private log(message: string) {
		this._messagesService.add('ClientService: ' + message);
	}
}



// WEBPACK FOOTER //
// ./src/app/services/client.service.ts